import React from 'react';
import { Tag } from 'antd-v5';

export const PurchaseTypeTag = ({ type }) => {
  if (!type) return null;
  if (['SALE', 'RETURN', 'REPAIR', 'OTHER'].indexOf(type) === -1) return null;
  const config = {
    SALE: {
      color: 'green',
      text: 'Sale',
    },
    RETURN: {
      color: 'volcano',
      text: 'Return',
    },
    REPAIR: {
      color: 'gray',
      text: 'Repair',
    },
    OTHER: {
      color: 'gray',
      text: 'Other',
    },
  };

  return <Tag color={config[type].color}>{config[type].text}</Tag>;
};
